import { call, put, takeLatest } from "redux-saga/effects";

import {
  getTokenHoldersSuccess,
  getTokenHoldersFailure,
  getDistributionSuccess,
  getDistributionFailure,
} from "./TokenHolders.actions";
import { TokenHoldersService } from "./TokenHolders.store";

function* getTokenHoldersSaga(args) {
  try {
    const tokenHoldersService = new TokenHoldersService();

    const { data, total, rangeTotal } = yield call(
      tokenHoldersService.fetchTokenHolders,
      args
    );
    yield put(getTokenHoldersSuccess(data, total, rangeTotal));
  } catch (error) {
    yield put(getTokenHoldersFailure(error));
  }
}

function* getDistributionSaga(args) {
  try {
    const tokenHoldersService = new TokenHoldersService();

    const { distribution } = yield call(
      tokenHoldersService.fetchDistribution,
      args
    );
    yield put(getDistributionSuccess(distribution));
  } catch (error) {
    yield put(getDistributionFailure(error));
  }
}

export function* tokenHoldersSagas() {
  const GET_TOKENHOLDERS = "GET_TOKENHOLDERS";
  yield takeLatest(GET_TOKENHOLDERS, getTokenHoldersSaga);
  const GET_DISTRIBUTION = "GET_DISTRIBUTION";
  yield takeLatest(GET_DISTRIBUTION, getDistributionSaga);
}
